import { addEventListeners, removeEventListeners } from "../utils/dom";
import { Modal } from "bootstrap";

export default class FileDirectory extends HTMLDivElement {

    canDelete = false;

    get checkboxes() {
        return this.querySelectorAll("input[type=checkbox]");
    }

    get selectedCheckboxes() {
        return Array.from(this.querySelectorAll("input[type=checkbox]")).filter(input => input.checked);
    }

    get items() {
        return this.querySelectorAll(".file-directory-item");
    }

    get deleteButton() {
        return this.querySelector("#file-directory-delete");
    }

    get deleteModalElement() {
        return this.querySelector("#file-directory-delete-modal");
    }

    get deleteModal() {
        return Modal.getOrCreateInstance(this.deleteModalElement);
    }

    get fileModalElement() {
        return this.querySelector("#file-directory-file-modal");
    }

    get fileModal() {
        return Modal.getOrCreateInstance(this.fileModalElement);
    }

    get folderModalElement() {
        return this.querySelector("#file-directory-folder-modal");
    }

    get folderModal() {
        return Modal.getOrCreateInstance(this.folderModalElement);
    }

    get links() {
        return this.querySelectorAll("a[data-ajax-update]");
    }

    get forms() {
        return this.querySelectorAll("form[data-ajax='true']");
    }
    
    connectedCallback() {

        this.addLinkListeners();
        this.addFormListeners();

        this.canDelete = this.dataset.canDelete === 'true';

        if (this.canDelete) {

            this.deleteModalElement.addEventListener("show.bs.modal", this.handleShowDeleteModal);

            addEventListeners(this.items, "click", this.handleItemClick);

        }

    }

    disconnectedCallback() {

        this.removeLinkListeners();
        this.removeFormListeners();

        this.deleteModalElement?.removeEventListener("show.bs.modal", this.handleShowDeleteModal);

        removeEventListeners(this.items, "click", this.handleItemClick);

    }

    handleShowDeleteModal = (e) => {

        let fileDirectory = this.closest("[is='file-directory']");
        let seletedFilesList = this.querySelector("#file-directory-delete-modal ul");

        seletedFilesList.innerHTML = "";

        const selectedItems = Array.from(fileDirectory.querySelectorAll(".file-directory-list :checked"))
            .map(item => item.closest(".file-directory-item"));

        selectedItems.forEach(item => {
            seletedFilesList.appendChild(item.cloneNode(true));
        });

    }

    handleItemClick = (e) => {

        const clickedTarget = e.target;
        const clickedTagName = clickedTarget.tagName.toLowerCase();

        // Handle link click as normal
        if (clickedTagName === "a") {
            return;
        }

        e.stopPropagation();

        let checkbox = null;

        if (clickedTagName === "input") {
            checkbox = clickedTarget;
        }
        else {
            checkbox = clickedTarget.closest(".file-directory-item-selectable").querySelector("input");
        }

        // Input and label will handle toggling by default.
        // But need to handle click on other elements like li
        if (clickedTagName !== "input" && clickedTagName !== "label") {
            checkbox.checked = !checkbox.checked;
        }

        clickedTarget.closest(".file-directory-item").classList.toggle("file-directory-item-selected", checkbox.checked);

        this.deleteButton.disabled = this.selectedCheckboxes === null;
    }

    closeModals() {

        this.deleteModal.hide();
        this.fileModal.hide();
        this.folderModal.hide();

    }

    addLinkListeners() {
        if (this.links) {
            this.links.forEach(link => {
                link.addEventListener("click", this.handleLinkClick);
            });
        }
    }

    removeLinkListeners() {
        if (this.links) {
            this.links.forEach(link => {
                link.removeEventListener("click", this.handleLinkClick);
            });
        }
    }

    addFormListeners() {
        if (this.forms) {
            this.forms.forEach(form => {
                form.addEventListener("submit", this.handleFormSubmit.bind(this));
            });
        }
    }

    removeFormListeners() {
        if (this.forms) {
            this.forms.forEach(form => {
                form.removeEventListener("submit", this.handleFormSubmit.bind(this));
            });
        }
    }

    async handleLinkClick(event) {
        event.preventDefault();

        const link = event.currentTarget;
        const url = link.href;
        const targetSelector = link.getAttribute("data-ajax-update");

        if (!targetSelector) {
            console.warn("No target selector specified for AJAX update.");
            return;
        }

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Accept": "text/html"
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const html = await response.text();
            const targetElement = document.querySelector(targetSelector);

            if (targetElement) {
                targetElement.innerHTML = html;
            } else {
                console.warn(`Target element '${targetSelector}' not found.`);
            }
        } catch (error) {
            console.error("Error during AJAX request:", error);
        }
    }


    async handleFormSubmit(event) {
        event.preventDefault();

        const form = event.currentTarget;
        const url = form.action;
        const method = form.method || "GET";
        const updateTargetSelector = form.getAttribute("data-ajax-update");
        const updateTarget = document.querySelector(updateTargetSelector);

        if (!updateTargetSelector || !updateTarget) {
            console.error("Missing or invalid data-ajax-update target.");
            return;
        }

        try {
            const formData = new FormData(form);

            const response = await fetch(url, {
                method: method.toUpperCase(),
                body: method.toUpperCase() === "POST" ? formData : undefined,
                headers: {
                    "Accept": "text/html"
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const html = await response.text();
            updateTarget.innerHTML = html;

            // Close modal if open
            const modalParent = form.closest(".modal");
            if (modalParent) {
                const bootstrapModal = Modal.getInstance(modalParent);
                if (bootstrapModal) {
                    bootstrapModal.hide();
                }
            }
        } catch (error) {
            console.error("Error during AJAX form submission:", error);
        }
    }

}

customElements.define('file-directory', FileDirectory, { extends: 'div' });